import React, { Component, useEffect, useRef, useState } from "react";
import { Modal, Button } from "react-bootstrap";
import { getAlert } from "../../../services/appAlerts";
import useControls from "../../../app/hooks/useControls";
import useForm from "../../../app/hooks/useForm";
import { getCurrentUser } from "../../../app/store/auth";
import { useDispatch, useSelector } from "react-redux";
import {
  SendAddedEmailMessage,
  addNewEmailMessage, emailMessageAdded,
  getEmailAddedStatus, getEmailUpdatedStatus, getMailDocUploadSasRes, getSentEmailStatus, updateEmailMessage
} from "../../../app/store/users";
import { uploadFileToBlob } from "../../../services/blobUploadService";
import UploadDocument from "../../../comman/UploadDocument";

const formatFileSize = (bytes) => {
  if (bytes === 0) return "0 Bytes";
  const k = 1024;
  const sizes = ["Bytes", "KB", "MB", "GB"];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + " " + sizes[i];
};

const SendEmail = (props) => {
  const { 
    showHide, 
    handleModalShowHide, 
    selectedEmail,
    selectedObj, 
    viewType, 
    selectedMailObj, 
    handleUpdateModalShowHide, 
    msgType, 
    isInline 
  } = props;

  const [saveBtnType, setSaveBtnType] = useState("");
  const [saveBtnProcess, setSaveBtnProcess] = useState(false);
  const [draftBtnProcess, setDraftBtnProcess] = useState(false);
  const [documents, setDocuments] = useState([]);

  const emailAddedStatusSelector = useSelector(getEmailAddedStatus);
  const sentEmailStatusSelector = useSelector(getSentEmailStatus);
  const emailUpdatedStatusSelector = useSelector(getEmailUpdatedStatus);
  const mailDocUploadSasResSelector = useSelector(getMailDocUploadSasRes);

  const currentUser = getCurrentUser();
  const dispatch = useDispatch();
  const fileInputRef = useRef(null);

  useEffect(() => {
    const dt = {};
    if (selectedObj) {
      dt["emailTo"] = selectedObj.performeremail;
      dt["performerId"] = selectedObj.performerid;
      dt["ciid"] = selectedObj.ciid;
      dt["wiid"] = selectedObj.wiid;
      dt["iiid"] = selectedObj.iiid;
      dt["emails"] = [{ key: selectedObj.performerid, value: selectedObj.performeremail }];
    }

    if (selectedEmail?.length > 0) {
      dt["emailTo"] = selectedEmail.map((x) => x.value).join(", ");
      dt["emails"] = selectedEmail;
    }

    dt["subject"] = "";
    dt["mailBody"] = "";
    dt["addedBy"] = currentUser.id;

    setStateData(dt);
  }, [selectedObj, selectedEmail]);

  useEffect(() => {
    const dt = {};
    if (selectedMailObj) {
      dt["emailTo"] = selectedMailObj.emailTo;
      dt["id"] = selectedMailObj.id;
      dt["subject"] = selectedMailObj.subject;
      dt["mailBody"] = selectedMailObj.mailBody;
      setStateData(dt);
    }
  }, [selectedMailObj]);

  const schema = {};

  useEffect(() => {
    if (emailAddedStatusSelector) {
      setSaveBtnProcess(false);
      setDraftBtnProcess(false);
      if (saveBtnType === "draft") {
        getAlert("Saved Successfully", "", "success");
      }
      handleModalShowHide("save");
      dispatch(emailMessageAdded(false));
      setStateData({});
      setDocuments([]);
    }
  }, [emailAddedStatusSelector]);

  useEffect(() => {
    if (emailUpdatedStatusSelector) {
      getAlert("Updated Successfully", "", "success");
      setSaveBtnProcess(false);
      setDraftBtnProcess(false);
      if (handleUpdateModalShowHide) handleUpdateModalShowHide();
    }
  }, [emailUpdatedStatusSelector]);

  const doSubmit = (btnType) => {
    setSaveBtnType(btnType);
    const payload = {
      emailTo: selectedEmail?.map(x => x.value).join(", ") || stateData.emailTo || "",
      emails: JSON.stringify(selectedEmail || []),
      subject: stateData.subject || "",
      emailFrom: stateData.emailFrom || "",
      mailBody: stateData.mailBody || "",
      addedBy: Number(stateData.addedBy) || 0,
      ciid: Number(stateData.ciid) || 0,
      wiid: Number(stateData.wiid) || 0,
      iiid: Number(stateData.iiid) || 0,
      sendStatus: btnType === "send",
      files: documents?.map(x => ({
        name: x.name,
        type: x.type,
        size: x.size
      })) || []
    };

    if (btnType === "send") {
      setSaveBtnProcess(true);
    } else if (btnType === "draft") {
      setDraftBtnProcess(true);
    }

    if (btnType === "Update") {
      dispatch(updateEmailMessage(payload));
    } else {
      dispatch(addNewEmailMessage(payload));
    }
  };

  useEffect(() => {
    const uploadAllDocuments = async () => {
      if (mailDocUploadSasResSelector?.sasUrls?.length > 0) {
        try {
          getAlert("Sent Successfully", "", "success");
          await Promise.all(
            documents.map((file, key) =>
              uploadFileToBlob(
                file.file,
                mailDocUploadSasResSelector.sasUrls[key]?.uploadUrl,
                () => {}
              )
            )
          );
          if (saveBtnType === "send") {
            mailDocUploadSasResSelector.historyIds.forEach(historyId => {
              dispatch(SendAddedEmailMessage(historyId));
            });
          }
        } catch (error) {
          console.error("Upload failed:", error);
        }
      }
    };
    uploadAllDocuments();
  }, [mailDocUploadSasResSelector]);

  const onFileChange = async (event) => {
    const docs = [...documents];
    for (const file of event.target.files) {
      var doc = {
        name: file.name,
        type: file.type,
        size: file.size,
        file: file,
      };
      docs.push(doc);
    }
    setDocuments(docs);
    setStateData((prevState) => ({
      ...prevState,
      documents: docs
    }));
  };

  const handleFileRemove = (item) => {
    const updatedDocuments = documents.filter((doc) => doc !== item);
    setDocuments(updatedDocuments);
  };

  const modalClose = () => {
    setStateData({});
    setDocuments([]);
    handleModalShowHide("");
  };

  const { handleChange, stateData, setStateData, stateErrors, handleSubmit } = useForm(schema, doSubmit);
  const { renderInput, renderTextArea } = useControls(stateData, stateErrors, handleChange, schema);

  const getRecipientEmails = () => {
    if (selectedEmail?.length > 0) {
      return selectedEmail.map(x => x.value);
    }
    if (stateData.emailTo) {
      return stateData.emailTo.split(",").map(e => e.trim()).filter(e => e);
    }
    return [];
  };

  const renderFormContent = () => {
    const recipientEmails = getRecipientEmails();
    
    return (
    <div className="awp-form-body pt-2">
      <div className="row">
        <div className="col-md-12 form-group">
          <label className="form-control-label">
            <i className="fa fa-users" aria-hidden="true" />
            To Recipients {recipientEmails.length > 0 && <span className="awp-req ml-2">({recipientEmails.length})</span>}
          </label>
          <div className="wf-badges-container">
            {recipientEmails.length > 0 ? (
              recipientEmails.map((email, idx) => (
                <span key={idx} className="wf-recipient-badge">
                  <i className="fa fa-envelope" aria-hidden="true" /> {email}
                </span>
              ))
            ) : (
              <span className="text-muted small" style={{ padding: "4px 0" }}>No recipients available</span>
            )}
          </div>
        </div>

        <div className="col-md-12 form-group">
          <label className="form-control-label">
            <i className="fa fa-bookmark" aria-hidden="true" /> Subject
          </label>
          <div className="wf-input-wrap">
            <i className="fa fa-pencil wf-input-icon" aria-hidden="true" />
            <input
              type="text"
              name="subject"
              className="form-control"
              placeholder="Enter subject line..."
              value={stateData.subject || ""}
              onChange={handleChange}
              autoComplete="off"
            />
          </div>
        </div>

        <div className="col-md-12 form-group">
          <label className="form-control-label">
            <i className="fa fa-align-left" aria-hidden="true" /> Message Body
          </label>
          <div className="wf-input-wrap">
            <i className="fa fa-pencil-square-o wf-input-icon wf-input-icon-top" aria-hidden="true" />
            <textarea
              name="mailBody"
              className="form-control"
              rows="6"
              placeholder="Type your message here..."
              value={stateData.mailBody || ""}
              onChange={handleChange}
            />
          </div>
        </div>

        <div className="col-md-12 form-group mb-0">
          <UploadDocument
            documents={documents}
            onFileChange={onFileChange}
            handleFileRemove={handleFileRemove}
            btnLable="Add Attachment"
          />
        </div>
      </div>
    </div>
  );
  };

  const styles = `
    .awp-card {
      border: 1px solid rgba(226,232,240,0.8);
      border-radius: 16px;
      background: #ffffff;
      box-shadow: 0 4px 24px -4px rgba(15,23,42,0.06);
      margin-top: 10px;
      animation: awpFadeIn 0.3s ease both;
      overflow: hidden;
    }
    
    @keyframes awpFadeIn {
      from { opacity: 0; transform: translateY(6px); }
      to   { opacity: 1; transform: translateY(0); }
    }

    .awp-form-header {
      display: flex; align-items: center; gap: 14px;
      padding: 16px 22px;
      background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
      border-bottom: 1.5px solid #e2e8f0;
      position: relative; overflow: hidden;
    }
    .awp-form-header-icon {
      width: 42px; height: 42px; border-radius: 12px;
      background: rgba(37,99,235,0.06); border: 1.5px solid rgba(37,99,235,0.1);
      display: flex; align-items: center; justify-content: center;
      font-size: 17px; color: #2563eb; flex-shrink: 0;
    }
    .awp-form-header-title {
      color: #0f172a; font-size: 14.5px; font-weight: 800; margin: 0; line-height: 1.2;
    }
    .awp-form-header-sub {
      color: #64748b; font-size: 12px; margin-top: 3px; font-weight: 500;
    }

    .awp-form-body { padding: 18px 22px; }

    .awp-card .form-control-label {
      font-size: 11px !important; font-weight: 700 !important; color: #64748b !important;
      text-transform: uppercase !important; letter-spacing: 0.7px !important;
      margin-bottom: 6px !important; display: flex !important;
      align-items: center !important; gap: 5px !important;
    }
    .awp-card .form-group { margin-bottom: 16px; }

    .wf-badges-container {
      display: flex;
      flex-wrap: wrap;
      gap: 8px;
      padding: 10px 14px;
      background: #f8fafc;
      border: 1.5px solid #e2e8f0;
      border-radius: 10px;
      min-height: 42px;
      box-shadow: inset 0 1px 2px rgba(0,0,0,0.02);
    }

    .wf-recipient-badge {
      display: inline-flex;
      align-items: center;
      gap: 6px;
      background: #ffffff;
      border: 1px solid #cbd5e1;
      padding: 5px 12px;
      border-radius: 8px;
      font-size: 12.5px;
      font-weight: 600;
      color: #334155;
      box-shadow: 0 1px 2px rgba(0,0,0,0.02);
    }

    .wf-recipient-badge i {
      color: #2563eb;
      font-size: 11.5px;
    }

    .awp-card .wf-input-wrap { position: relative; }
    .awp-card .wf-input-icon {
      position: absolute; left: 12px; top: 50%; transform: translateY(-50%);
      color: #94a3b8; font-size: 13px; pointer-events: none;
      transition: color 0.2s ease; z-index: 1;
    }
    .awp-card .wf-input-icon.wf-input-icon-top {
      top: 14px;
      transform: none;
    }
    .awp-card .wf-input-wrap:focus-within .wf-input-icon { color: #2563eb; }

    .awp-card .form-control {
      border-radius: 9px !important;
      border: 1.5px solid #e2e8f0 !important;
      padding: 8px 13px 8px 35px !important;
      font-size: 13px !important;
      color: #1e293b !important;
      background: #ffffff !important;
      transition: all 0.2s cubic-bezier(0.4,0,0.2,1) !important;
      box-shadow: 0 1px 3px 0 rgba(0,0,0,0.03) !important;
      width: 100% !important;
      height: auto !important;
    }
    .awp-card .form-control:focus {
      border-color: #2563eb !important;
      box-shadow: 0 0 0 4px rgba(37,99,235,0.1) !important;
      outline: none !important; background: #fafbff !important;
    }

    .awp-form-footer {
      display: flex; align-items: center; justify-content: flex-end;
      gap: 10px; flex-wrap: wrap; padding: 14px 22px;
      border-top: 1.5px solid #f1f5f9; background: #fafbfd;
    }

    .awp-req {
      color: #ef4444; font-weight: 800; font-size: 12px;
    }
    
    .btn-action-search {
      display: inline-flex !important; align-items: center !important; gap: 8px !important;
      background: #ffffff !important; border: 1.5px solid #cbd5e1 !important;
      padding: 8px 16px !important; border-radius: 9px !important;
      font-size: 13px !important; font-weight: 700 !important; color: #475569 !important;
      cursor: pointer !important; transition: all 0.2s !important;
    }
    .btn-action-search:hover {
      background: #f8fafc !important; border-color: #94a3b8 !important; color: #1e293b !important;
      transform: translateY(-1px) !important;
    }
    .btn-primary-search {
      background: #2563eb !important; color: #ffffff !important; border-color: #2563eb !important;
    }
    .btn-primary-search:hover {
      background: #1d4ed8 !important; box-shadow: 0 4px 12px rgba(37,99,235,0.2) !important;
    }
  `;

  if (isInline) {
    return (
      <div className="awp-card">
        <style>{styles}</style>
        <div className="awp-form-header">
          <div className="awp-form-header-icon">
            <i className="fa fa-envelope" />
          </div>
          <div className="awp-form-header-text">
            <p className="awp-form-header-title">
              {selectedEmail?.length > 0 ? "Compose Bulk Message" : "Compose Message"}
            </p>
            <p className="awp-form-header-sub">
              {selectedEmail?.length > 0 ? `Sending to ${selectedEmail.length} selected recipients` : "Type your message and manage attachments below"}
            </p>
          </div>
        </div>
        <div className="awp-form-body">
          {renderFormContent()}
        </div>
        <div className="awp-form-footer">
          <button
            type="button"
            className="btn-action-search mr-auto"
            onClick={modalClose}
          >
            <i className="fa fa-arrow-left" aria-hidden="true" />
            Back to Registry
          </button>
          {viewType === "edit" &&
            <button className="btn-action-search btn-primary-search" disabled={saveBtnProcess} onClick={() => handleSubmit("Update")}>
              {saveBtnProcess ? <i className="fa fa-circle-o-notch fa-spin"></i> : <i className="fa fa-pencil" aria-hidden="true"></i>} Update Message
            </button>
          }
          {viewType === "add" && <>
            <button className="btn-action-search" disabled={draftBtnProcess} onClick={() => handleSubmit("draft")}>
              {draftBtnProcess ? <i className="fa fa-circle-o-notch fa-spin"></i> : <i className="fa fa-check" aria-hidden="true"></i>} Save as Draft
            </button>
            <button className="btn-action-search btn-primary-search" disabled={saveBtnProcess} onClick={() => handleSubmit("send")}>
              {saveBtnProcess ? <i className="fa fa-circle-o-notch fa-spin"></i> : <i className="fa fa-paper-plane" aria-hidden="true"></i>} Send Message
            </button> </>
          }
        </div>
      </div>
    );
  }

  return (
    <Modal show={showHide} size="xl" centered onHide={modalClose}>
      <div className="awp-card" style={{ margin: 0, border: "none" }}>
        <style>{styles}</style>
        <div className="awp-form-header">
          <div className="awp-form-header-icon">
            <i className="fa fa-envelope" />
          </div>
          <div className="awp-form-header-text">
            <p className="awp-form-header-title">
              {selectedEmail?.length > 0 ? "Send Bulk Email" : "Send Message"}
            </p>
            <p className="awp-form-header-sub">
              {selectedEmail?.length > 0 ? `Recipient count: ${selectedEmail.length}` : "Transmit correspondence to the selected performer"}
            </p>
          </div>
          <button type="button" className="close ml-auto" onClick={modalClose} style={{ outline: "none" }}>
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div className="awp-form-body">
          {renderFormContent()}
        </div>
        <div className="awp-form-footer">
          <button className="btn-action-search mr-auto" onClick={modalClose}>
            <i className="fa fa-times" aria-hidden="true" /> Close
          </button>
          {viewType === "edit" &&
            <button className="btn-action-search btn-primary-search" disabled={saveBtnProcess} onClick={() => handleSubmit("Update")}>
              {saveBtnProcess ? <i className="fa fa-circle-o-notch fa-spin" /> : <i className="fa fa-pencil" aria-hidden="true" />} Update Message
            </button>
          }
          {viewType === "add" && <>
            <button className="btn-action-search" disabled={draftBtnProcess} onClick={() => handleSubmit("draft")}>
              {draftBtnProcess ? <i className="fa fa-circle-o-notch fa-spin"></i> : <i className="fa fa-check" aria-hidden="true" />} Save as Draft
            </button>
            <button className="btn-action-search btn-primary-search" disabled={saveBtnProcess} onClick={() => handleSubmit("send")}>
              {saveBtnProcess ? <i className="fa fa-circle-o-notch fa-spin"></i> : <i className="fa fa-paper-plane" aria-hidden="true" />} Send Message
            </button> </>
          }
        </div>
      </div>
    </Modal>
  );
};

export default SendEmail;
